module.exports = __webpack_public_path__ + "static/media/wifi.f3b440ec.svg";